import React, { useEffect, useState } from "react";
import { FaUser, FaUserCheck, FaUserClock, FaUserTimes } from "react-icons/fa";
// import Card from "../../../components/card/Card";
import DashHeader from "../../../components/dashHeader/DashHeader";
import Sticker from "../../../components/sticker/Sticker";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTenants, updateTenant } from "../../../redux/slices/tenantSlice";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getAuthTokenData } from "../../../utils/tokenUtils";
import { roles, routeNames } from "../../../constants/constants";
import { Card } from "@/components/ui/card";
import { SetTable } from "@/components/SetTable";
import InputField from "@/components/inputField/InputField";
import { searchIcon } from "assets";
import SimpleCard from "@/components/simple-card";

const Tenants: React.FC = () => {
  const location = useLocation();
  const { buildingId } = location.state || {};
  const { userId, role } = getAuthTokenData();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("pending");
  const { tenants } = useSelector((state: RootState) => state.tenants);
  const dispatch = useDispatch<AppDispatch>();

  const statuses: Record<string, string> = {
    approved: "Approved",
    pending: "Pending",
    rejected: "Expired",
  };

  const handleUpdateStatus = async (tenantId: string, status: string, isActive: boolean) => {
    try {
      const resultAction = await dispatch(
        updateTenant({ id: tenantId, payload: { status, isActive } })
      );

      if (updateTenant.fulfilled.match(resultAction)) {
        toast.success(`Tenant updated to status ${status} successfully`);
      } else if (updateTenant.rejected.match(resultAction)) {
        toast.error(`Failed to update tenant to status ${status}`);
      }
    } catch (error) {
      console.error(`Error updating tenant to ${status}:`, error);
    }
  };

  const handleApprove = (tenant: any) =>
    handleUpdateStatus(tenant._id, "Approved", true);
  const handleReject = (tenant: any) =>
    handleUpdateStatus(tenant._id, "Expired", false);

  const filterTenants = (tenantsList: any[]): any[] => {
    if (tenantsList.length === 0) return [];
    return tenantsList.filter(
      (tenant) =>
        tenant.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        tenant.username.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  const filteredTenants = filterTenants(
    tenants?.filter((tenant) => tenant.status === statuses[activeTab]) || []
  );

  useEffect(() => {
    dispatch(fetchTenants({ building: buildingId, role: "Tenant" }));
  }, [dispatch, buildingId, activeTab]);

  const handleViewTenant = (item: any) => {
    navigate(`${routeNames.tenantDetail}/${item._id}`, {
      state: { tenant: item },
    });
  };
  const tenantstableKeys = [
    {
      name: "name",
    },
    {
      username: "username",
    },
    {
      contact: "contactNumber",
    },
    {
      flatNo: "flatNo",
    },
  ];

  const actions = [
    {
      label: "Approved",

      handler: (row: any) => handleApprove(row),
    },
    {
      label: "Expired",
      handler: (row: any) => handleReject(row),
    },
    {
      label: "Details",
      handler: (row: any) => handleViewTenant(row),
    },

  ];
  return (
    <div className="p-6">
      {/* <DashHeader title="Tenants Management" />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-6">
        <Sticker
          title="Total Tenants"
          number={tenants?.length}
          icon={FaUser}
        />
        <Sticker
          title="Approved Tenants"
          number={tenants?.filter((t) => t.status === "Approved").length}
          icon={FaUserCheck}
        />
        <Sticker
          title="Pending Requests"
          number={tenants
            .filter((t) => t.status === "Pending")
            .length}
          icon={FaUserClock}
        />
        <Sticker
          title="Rejected Tenants"
          number={tenants
            .filter((t) => t.status === "Expired")
            .length}
          icon={FaUserTimes}
        />
      </div> */}
      <h1 className=" py-5 text-3xl font-bold tracking-tight">Tenants Management</h1>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-6">
        <SimpleCard title="Total Tenants" number={tenants?.length} description="+2% from last month" Icon={FaUser} />
        <SimpleCard title="Approved Tenants" number={tenants?.filter((t) => t.status === "Approved").length} description="+2% from last month" Icon={FaUserCheck} />
        <SimpleCard title="Pending Requests" number={tenants
          .filter((t) => t.status === "Pending")
          .length} description="+2% from last month" Icon={FaUserClock} />
        <SimpleCard title="Rejected Tenants" number={tenants
          .filter((t) => t.status === "Expired")
          .length} description="+2% from last month" Icon={FaUserTimes} />
      </div>

      {/* <div className="mt-8 mb-4">
        <input
          type="text"
          placeholder="Search tenants..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-3 rounded-lg border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div> */}
      <div className="flex px-3  w-full md:w-[327px] my-5">
        <InputField name="search" type="text" placeholder="Search Here..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} icon={searchIcon} />
      </div>

      <div className="flex border-b border-gray-200">
        {["pending", "approved", "rejected"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`py-2 px-6 font-medium text-sm ${activeTab === tab
              ? "border-b-2 border-blue-500 text-blue-500"
              : "text-gray-500"
              } transition`}
          >
            {tab === "pending"
              ? "Pending Requests"
              : tab === "approved"
                ? "Tenants List"
                : "Rejected Tenants"}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {/* {filteredTenants.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredTenants.map((item, i) => (
                <div key={i} className="shadow-lg p-4 border border-gray-200">
                  <Card item={item} isProfile />
                  {activeTab === "pending" && (
                    <div className="mt-4 flex justify-between">
                      <button
                        className="font-semibold text-red-500 border border-red-500 py-2 px-4 hover:bg-red-500 hover:text-white transition duration-300"
                        onClick={() => handleReject(item)}
                      >
                        Reject
                      </button>
                      <button
                        className="font-semibold text-green-500 border border-green-500 py-2 px-4 hover:bg-green-500 hover:text-white transition duration-300"
                        onClick={() => handleApprove(item)}
                      >
                        Approve
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 mt-4">No matching tenants found.</p>
          )} */}
        <Card className="p-5 col-span-7">
          <SetTable data={filteredTenants} tableKeys={tenantstableKeys} actions={actions} />
        </Card>
      </div>
    </div>
  );
};

export default Tenants;
